<template>
    <div class="layout">
        <Header></Header>
        <router-view></router-view>
        <Footer></Footer>
    </div>
</template>
<script>
    import Header from "@/components/Header"
    import Footer from "@/components/Footer"
    export default {
        components: {
            Header,
            Footer
        }
    }
</script>
<style lang="scss" scoped>
    .layout {
        padding-top: 90px;
    }
    @media screen and (max-width: 800px) {
        .layout {
            padding-top: 180px;
        }
    }
</style>